/**
 * 기본환경설정 (/adm/config)
 * ($j.Pages.Admin.Config / body data-page-name="Config")
 *
 * 회원 목록 필드(.member-picker) — 평소엔 '이름#번호' 로 나열만 하고, [편집] 을 누르면
 * 모달에서 검색·추가·삭제한다. 모달의 '확인' 이 곧 저장이다 — 페이지의 자동저장이
 * hidden 의 change 를 듣고 그 자리에서 보낸다(`_commit`). 하단 [저장] 버튼은 없어졌다.
 * (모달에서 '취소' 하면 그 편집분은 버려진다)
 *
 * Blade 는 빈 셸만 준다 — <div class="member-picker" data-name data-label data-items='[…]'>.
 * 칩·편집버튼·hidden input 까지 전부 여기서 그린다. 모달은 $j.Ui.JBModal.
 *
 * 상태의 정본은 각 위젯의 data-items(JSON). 폼 전송값은 그걸 옮겨담은 hidden input 의 회원번호 CSV.
 * ⚠ hidden 을 JS 가 만들므로, 스크립트가 죽으면 그 필드는 전송 자체가 안 된다.
 *   서버(ConfigController::saveConfig)는 '키가 없으면 건드리지 않게' 되어 있어 명단이 날아가지 않는다.
 *
 * 그 밖에 이 화면의 자동저장·앱 탭·관리자 접속 IP 제한도 여기 있다 (예전 blade 인라인 스크립트).
 * 버튼은 data-cfg="메서드명" 으로 부른다 — window 에 함수를 내놓지 않는다.
 */
import Util from '../../Common/Util';

const SEARCH_URL = '/adm/ajax/config/member-search';
const MODAL_ID   = 'mp-edit-modal';
const DEBOUNCE_MS = 250;

const CHIP_ACTIONS  = ['showStoreTestLogins'];
const CLICK_ACTIONS = ['copyAdmAuthUrl', 'regenAdmToken', 'openAdmIpGrants', 'revokeAdmGrant'];

export default class Config {
    initialize() {
        this.$picker = null;   // 편집 중인 위젯
        this.items = [];       // 모달에서 편집 중인 목록 (확인 전까지 위젯에 반영 안 함)
        this.timer = null;

        const self = this;

        $('.member-picker').each((i, el) => this._renderPicker($(el)));

        $(document).on('click', '.member-picker .mp-edit', function () {
            self._open($(this).closest('.member-picker'));
        });

        // data-chip-action 이 있는 위젯은 회원명이 버튼 역할을 한다.
        // (예: 앱마켓 심사용 계정 → 회원명 클릭 시 로그인 기록 모달)
        // 부를 수 있는 것은 CHIP_ACTIONS 에 적은 메서드뿐이다.
        $(document).on('click', '.member-picker .mp-chip.is-clickable', function () {
            const name = $(this).closest('.member-picker').data('chip-action');
            if (CHIP_ACTIONS.includes(name)) self[name](parseInt($(this).data('num')));
        });

        // 회원번호가 연결된 재직 관리자 — 편집 모달의 '관리자 전체 등록' 이 쓴다
        const el = document.getElementById('page-data');
        this.adminMembers = (el ? JSON.parse(el.textContent) : {}).adminMembers || [];

        // 버튼 — data-cfg="메서드명" (임시허용 IP 모달의 [해제] 는 data-n 에 번호)
        $(document).on('click', '[data-cfg]', function () {
            const name = this.dataset.cfg;
            if (CLICK_ACTIONS.includes(name)) self[name](this.dataset.n !== undefined ? Number(this.dataset.n) : undefined);
        });

        // 칸마다 그 자리에서 저장하므로 폼 전송(엔터)은 막는다
        $('#fconfigform').on('submit', (e) => e.preventDefault());

        this._initAutoSave();
        this._initAppTabs();

        /* ── 관리자 접속 IP 제한 ── */
        // 'IP 제한 사용' 체크 시에만 상세 항목(접속IP·기간·특수주소) 노출
        const toggleAdmIpDetail = () => $('#admIpDetail').toggle($('#adm_ip_gate_on').is(':checked'));
        $('#adm_ip_gate_on').on('change', toggleAdmIpDetail);
        toggleAdmIpDetail();
    }

    /* ── 자동저장 ─────────────────────────────────────────────────────────
     * 칸을 고치면 그때그때 저장한다. 하단 [저장] 버튼을 대신하고, 결과는 공용
     * 토스트($j.Ui.Toast — 이 페이지의 특수주소 복사·재생성과 같은 것)로 알린다.
     *
     * **바뀐 칸만 보낸다.** 서버(ConfigController::saveConfig)가 '요청에 실려온 키만' 저장하도록
     * 바뀌었다 — 예전엔 고정 묶음을 통째로 UPDATE 해서 한 칸만 보내면 나머지가 빈 값으로 덮였다.
     * 덕분에 저장 한 번이 건드리는 컬럼이 하나고, 두 관리자가 각자 다른 칸을 고쳐도 서로를
     * 되돌리지 않는다.
     *
     * 저장 후 새로고침하지 않는다 — 예전엔 저장하면 페이지를 다시 열었지만, 지금은 고치는
     * 중에 다시 열리면 커서와 스크롤이 날아간다. 값 정규화(발신번호 콤마 합치기 등)는
     * 다음에 페이지를 열 때 반영된다.
     */
    _initAutoSave() {
        const self = this;
        let inFlight = null, pending = false, dirty = false;
        let marked = [], sending = [];   // marked: 아직 안 보낸 칸 / sending: 지금 요청에 실린 칸

        function send() {
            // 저장 중에 또 고치면, 지금 것이 끝난 뒤 한 번만 더 보낸다(요청이 겹치지 않게).
            if (inFlight) { pending = true; return; }
            dirty = false;
            sending = marked; marked = [];
            inFlight = $.ajax({
                type: 'POST', dataType: 'json',
                url: '/adm/ajax/config/save',
                data: self._cfgPayload(sending)
            }).done(function (d) {
                // 성공은 **토스트로 알리지 않는다** — 칸에 직접 표시되므로 같은 말을 두 곳에서
                // 하는 셈이고, 자동저장이라 토스트가 자주 뜨면 그것부터 눈에 거슬린다.
                if (d && d.result) { self._cfgFlash(sending); self._cfgSyncAppOrig(); }
                else               $j.Ui.Toast.show((d && d.message) || '저장하지 못했습니다.', { type: 'error' });
            }).fail(function () {
                $j.Ui.Toast.show('저장하지 못했습니다 — 연결을 확인하세요.', { type: 'error' });
            }).always(function () {
                inFlight = null;
                if (pending) { pending = false; send(); }
            });
        }

        // 칸을 차례로 고쳐도 마지막 편집 뒤 한 번만 나간다 — 칸마다 보내면 다섯 칸 고치는 데
        // 요청이 다섯 번이다.
        //
        // 2초는 길었다. 저장 표시가 **칸에 직접** 뜨게 되면서 사람이 그 칸을 보며 기다리게
        // 됐기 때문이다(토스트일 땐 시선이 위로 가 있어 덜 느껴졌다). 칸 사이를 옮기는 데
        // 걸리는 시간(탭 한 번)보다는 길고, 기다린다는 느낌은 안 드는 선으로 줄인다.
        const later = Util.debounce(send, 600);

        // 마지막 편집 뒤 2초 안에 페이지를 떠나면 대기 중인 저장이 통째로 사라진다.
        // 떠나는 순간엔 $.ajax 가 중단되므로 sendBeacon 으로 한 번 더 밀어 넣는다.
        // (전 주소 CSRF 제외라 토큰 없이 나간다 — VerifyCsrfToken::$except)
        window.addEventListener('pagehide', function () {
            if (!dirty && !inFlight) return;
            try {
                navigator.sendBeacon('/adm/ajax/config/save',
                    new FormData(document.getElementById('fconfigform')));
            } catch (e) { /* 못 보내면 어쩔 수 없다 — 다음 편집에서 다시 나간다 */ }
        });

        // 뒤로가기 캐시(bfcache)로 돌아오면 떠날 때 화면이 통째로 복구된다 — 그 사이 남이 바꾼 값이
        // 옛 값으로 보이므로 복구된 화면은 서버에서 다시 받는다. 저장은 자동이라 잃을 입력이 없다.
        window.addEventListener('pageshow', function (e) { if (e.persisted) location.reload(); });

        // 부른 쪽이 '어느 칸 때문에' 저장하는지 알려준다 — 그 칸에 표시를 낸다
        const cfgSave = function (el) { if (el) marked.push(el); dirty = true; later(); };

        /* 언제 저장할 것인가 — 칸 종류마다 '편집이 끝난 순간'이 다르다.
         *
         *   글자칸(input·textarea) : 빠져나올 때(focusout). 치는 도중에 저장되면 곤란하다.
         *   체크·라디오·셀렉트     : 고르는 순간이 곧 편집 끝이라 change 를 그대로 쓴다.
         *   hidden                 : 회원 선택 위젯이 값을 넣고 change 를 쏜다 (_commit).
         *
         * ⚠ 글자칸에 blur 만 걸면 **아무것도 안 고치고 지나가도** 저장이 돌아 토스트가 뜬다.
         *   그래서 들어올 때 값을 적어두고, 나갈 때 달라졌을 때만 보낸다.
         * ⚠ name 없는 칸은 건너뛴다 — 폼에 실리지도 않는 모달 검색칸·읽기전용 표시칸이다.
         */
        const TEXTY = 'input:not([type=checkbox]):not([type=radio]):not([type=hidden]), textarea';
        const PICKY = 'input[type=checkbox], input[type=radio], input[type=hidden], select';

        $('#fconfigform')
            .on('focusin', TEXTY, function () { this.dataset.cfgPrev = this.value; })
            .on('focusout', TEXTY, function () {
                if (!this.name) return;
                if (this.dataset.cfgPrev === undefined || this.dataset.cfgPrev === this.value) return;
                this.dataset.cfgPrev = this.value;
                cfgSave(this);
            })
            .on('change', PICKY, function () {
                if (!this.name) return;
                cfgSave(this);
            });
    }

    /**
     * 저장된 칸을 **그 자리에서** 알린다 — 상단 토스트는 시선이 가 있는 곳과 멀다.
     * 방금 고친 칸 옆에 「저장됨」이 잠깐 떴다 사라지는 편이 "무엇이" 저장됐는지까지 말해준다.
     * (애니메이션이 끝나면 클래스를 떼서 다음 저장 때 다시 재생되게 한다)
     */
    _cfgFlash(els) {
        els.forEach(function (el) {
            const $box = $(el).closest('.form-group, .app-fld');
            if (!$box.length) return;
            $box.removeClass('is-saved');
            void $box[0].offsetWidth;          // 리플로우 강제 — 연속 저장에도 다시 재생된다
            $box.addClass('is-saved');
            setTimeout(function () { $box.removeClass('is-saved'); }, 1600);
        });
    }

    /**
     * 앱 묶음의 "열 때 값"(apps[JB][orig_*])을 지금 칸 값으로 맞춘다 — 저장이 성공한 직후에만.
     * 서버는 세 칸이 orig 와 같은 플랫폼을 "이 화면에서 안 고친 값"으로 보고 건너뛴다(AppVersionService::save).
     * 맞춰 두지 않으면, 고쳤다가 처음 값으로 되돌린 저장이 건너뛰어져 DB 가 중간 값에 멈춘다.
     */
    _cfgSyncAppOrig() {
        const $f = $('#fconfigform');
        ['latest_ver', 'min_ver', 'store_url', 'ios_latest_ver', 'ios_min_ver', 'ios_store_url'].forEach(function (k) {
            $f.find('[name$="][' + k + ']"][name^="apps["]').each(function () {
                const orig = $f.find('[name="' + this.name.replace('][' + k + ']', '][orig_' + k + ']') + '"]');
                if (orig.length) orig.val(this.value);
            });
        });
    }

    /**
     * 보낼 것만 추린다 — 바뀐 칸의 name 만 담아 직렬화한다.
     *
     * 앱 묶음(apps[JB][latest_ver] 등)만 예외다: AppVersionService::save() 가 한 플랫폼의 세 칸
     * (최신·최하·스토어주소)을 **한 번에 덮어쓰기** 때문에, 하나만 보내면 나머지 둘이 빈다.
     * 그래서 그 앱 것은 통째로 싣는다.
     */
    _cfgPayload(els) {
        const $f = $('#fconfigform');
        const names = new Set();

        els.forEach(function (el) {
            if (!el || !el.name) return;
            const m = /^apps\[([^\]]+)\]/.exec(el.name);
            if (m) $f.find('[name^="apps[' + m[1] + ']"]').each(function () { names.add(this.name); });
            else   names.add(el.name);
        });

        if (!names.size) return $f.serialize();   // 무엇이 바뀌었는지 모르면 종전처럼 전체

        return $f.find('[name]').filter(function () { return names.has(this.name); }).serialize();
    }

    /* ── 앱 버전 · 스토어 탭 ──
       숨긴 탭의 인풋도 폼에 그대로 실린다(display:none 은 serialize 대상) — 어느 탭에서 고쳐도
       자동저장이 폼 전체를 보내므로, 탭을 옮겨 다니며 고쳐도 앞엣것이 빈 값으로 덮이지 않는다. */
    _initAppTabs() {
        $('.app-tabs').on('click', 'button', function () {
            const code = $(this).data('app');
            $('.app-tabs button').removeClass('is-on').attr('aria-selected', 'false');
            $(this).addClass('is-on').attr('aria-selected', 'true');
            $('.app-pane').removeClass('is-on').filter('[data-app="' + code + '"]').addClass('is-on');
        });

        // 플랫폼 칩 — 앱 탭을 옮겨도 고른 플랫폼을 유지하도록 모든 앱에 함께 적용한다. 심사용 계정도 같이 따라간다
        $('.app-platform-chips').on('click', 'button', function () {
            const platform = $(this).data('platform');
            $('.app-platform-chips button').each(function () {
                const on = $(this).data('platform') === platform;
                $(this).toggleClass('is-on', on).attr('aria-pressed', on ? 'true' : 'false');
            });
            $('.app-platform, .app-store-test').each(function () {
                $(this).toggleClass('is-on', $(this).data('platform') === platform);
            });
        });
    }

    // 앱마켓 심사용 테스트 계정 로그인 기록 모달 (공용 $j.F.Admin.Util.showLoginLogs)
    // 회원 선택 위젯의 회원명을 누르면 호출된다(data-chip-action) — 인자로 그 회원번호가 넘어온다.
    // 아직 저장 전에 교체해둔 계정도 바로 조회되도록, 화면에서 고른 번호를 그대로 넘긴다.
    showStoreTestLogins(mbNo) {
        $j.F.Admin.Util.showLoginLogs({
            url: '/adm/ajax/config/store-test-logins',
            method: 'POST',
            data: mbNo ? { mb_no: mbNo } : undefined,
            title: '앱마켓 심사용 계정 로그인 기록',
            modalId: 'store-test-logins-modal',
        });
    }

    copyAdmAuthUrl() {
        const url = $('#adm_auth_url').val();
        if (!url) { alert('먼저 특수주소를 생성하세요.'); return; }
        navigator.clipboard.writeText(url).then(function () { $j.Ui.Toast.show('특수주소를 복사했습니다.', { type: 'success' }); },
            function () { const el = document.getElementById('adm_auth_url'); el.select(); document.execCommand('copy'); });
    }

    regenAdmToken() {
        if (!confirm('특수주소를 새로 만들면 기존 주소는 무효화됩니다. 계속할까요?')) return;
        $.ajax({ type: 'POST', dataType: 'json', url: '/adm/ajax/config/ip-token/regen',
            success: function (r) { if (r.result) { $('#adm_auth_url').val(r.url); $j.Ui.Toast.show('특수주소를 재생성했습니다.', { type: 'success' }); } } });
    }

    openAdmIpGrants() {
        $.ajax({ type: 'POST', dataType: 'json', url: '/adm/ajax/config/ip-grants', success: function (r) {
            if (!r.result) return;
            const rows = (r.list || []).map(function (g) {
                return '<tr><td>' + g.ip + '</td><td>' + (g.expires_at || '') +
                    '</td><td><button type="button" class="btn btn-sm btn-outline-danger" data-cfg="revokeAdmGrant" data-n="' + g.num + '">해제</button></td></tr>';
            }).join('');
            // width 는 속성으로 — DataTables 가 100% 를 style/width 속성에서만 읽는다
            const html = '<p class="frm_info mb-2">특수주소로 임시허용된 IP. 만료되면 자동 폐기되며, 유출 의심 시 즉시 [해제]. (내 IP: <b>' + (r.nowIp || '-') + '</b>)</p>' +
                '<table id="admIpGrantsTable" class="table table-bordered display" width="100%">' +
                '<thead><tr><th>IP</th><th>만료</th><th>해제</th></tr></thead><tbody>' + rows + '</tbody></table>';
            $j.Ui.JBModal.html('adm-ip-grants-modal', html, '임시허용 IP 목록', { width: '700px', onOpen: function () {
                if ($.fn.DataTable.isDataTable('#admIpGrantsTable')) $('#admIpGrantsTable').DataTable().destroy();
                $('#admIpGrantsTable').DataTable({
                    autoWidth: false,
                    ordering: true,
                    order: [[1, 'desc']],
                    pageLength: 10,
                    lengthChange: false,
                    columnDefs: [{ targets: 2, orderable: false, searchable: false }],
                    language: {
                        emptyTable: '임시허용된 IP가 없습니다.',
                        zeroRecords: '일치하는 결과가 없습니다.',
                        loadingRecords: '로딩 중...',
                        info: '총 _TOTAL_건', infoEmpty: '', infoFiltered: '',
                        search: '검색:',
                        paginate: { previous: "<i class='fa fa-chevron-left'></i>", next: "<i class='fa fa-chevron-right'></i>" }
                    }
                });
            } });
        } });
    }

    revokeAdmGrant(num) {
        if (!confirm('이 IP의 임시허용을 해제할까요?')) return;
        const self = this;
        $.ajax({ type: 'POST', dataType: 'json', url: '/adm/ajax/config/ip-grants/revoke', data: { num: num },
            success: function (r) { if (r.result) { self.openAdmIpGrants(); } } });   // 재조회 후 모달 갱신
    }

    /** 위젯 껍데기(빈 div) → 칩 + 편집버튼 + hidden input */
    _renderPicker($p) {
        const items = $p.data('items') || [];
        $p.html(`
            <input type="hidden" name="${$p.data('name')}" value="${items.map((x) => x.num).join(',')}">
            <div class="mp-view">
                <div class="mp-chips">${this._chipsHtml(items, $p)}</div>
                <button type="button" class="btn btn-sm btn-outline-secondary mp-edit">편집</button>
            </div>`);
    }

    _chipsHtml(items, $p) {
        if (!items.length) return '<span class="mp-none-txt">등록된 회원이 없습니다.</span>';
        const clickable = !!($p && $p.data('chip-action'));
        // **이름만 보인다.** 번호는 여기서 할 일이 없다 — 고르는 것은 모달이 하고, 이 줄은
        // '누가 들어 있나' 만 답하면 된다. 번호가 붙으면 이름이 그만큼 뒤로 밀린다.
        // 확인할 길은 남긴다: 마우스를 올리면 title 에 번호가 뜬다.
        return items.map((x) =>
            `<span class="mp-chip${x.left ? ' is-left' : ''}${clickable ? ' is-clickable' : ''}"
                   data-num="${x.num}" title="${clickable ? '로그인 기록 보기 · ' : ''}#${x.num}"
             >${this._esc(x.name)}</span>`).join('');
    }

    /* ───────────────────────── 모달 ───────────────────────── */

    _open($picker) {
        const self = this;
        this.$picker = $picker;
        this.max = parseInt($picker.data('max')) || 0;        // 0 = 무제한, 1 = 한 명만
        // data-no-admins — '관리자 전체 등록' 을 숨긴다. 명단에 들면 돈이 달라지는 필드(수수료 면제 등)용
        const addAdmins = this.max !== 1 && !$picker.data('no-admins');
        this.items = this._sort(($picker.data('items') || []).slice()); // 복사본을 편집 → 취소 시 원본 유지

        // 이번 편집에서 새로 넣은 회원을 표시하기 위한 기준선.
        // 확인을 누르면 이 회원들도 '기존'이 되므로, 모달을 열 때마다 다시 잡는다.
        this.original = new Set(this.items.map((x) => parseInt(x.num)));

        $j.Ui.JBModal.html(MODAL_ID, `
            <div class="mp-modal">
                <div class="mp-search">
                    <input type="text" class="form-control form-control-sm mp-input" autocomplete="off"
                           placeholder="이름 · 회원번호 · 전화번호로 검색">
                    <div class="mp-results" hidden></div>
                </div>
                <ul class="mp-list"></ul>
                <div class="mp-empty"></div>
                ${this.max === 1 ? '<div class="mp-note">이 항목은 <b>한 명만</b> 등록할 수 있습니다. 다른 회원을 고르면 기존 회원이 교체됩니다.</div>' : ''}
                <div class="mp-actions">
                    ${addAdmins ? '<button type="button" class="btn btn-sm btn-outline-primary mp-add-admins">관리자 전체 등록</button>' : ''}
                    <span class="mp-spacer"></span>
                    <button type="button" class="btn btn-sm btn-secondary mp-cancel">취소</button>
                    <button type="button" class="btn btn-sm btn-primary mp-apply">확인</button>
                </div>
            </div>
        `, $picker.data('label') || '회원 선택', { width: '520px', onOpen: ($m) => self._bind($m) });
    }

    _bind($m) {
        const self = this;
        this._renderList($m);

        $m.on('input', '.mp-input', function () {
            const kwd = $(this).val().trim();
            clearTimeout(self.timer);
            if (kwd === '') { self._hideResults($m); return; }
            self.timer = setTimeout(() => self._search($m, kwd), DEBOUNCE_MS);
        });

        // 검색칸 엔터로 폼이 제출되지 않게
        $m.on('keydown', '.mp-input', (e) => { if (e.key === 'Enter') e.preventDefault(); });

        $m.on('click', '.mp-result', function () {
            const d = $(this).data();
            self._add({ num: d.num, name: String(d.name), left: !!d.left });
            self._renderList($m);
            $m.find('.mp-input').val('').focus();
            self._hideResults($m);
        });

        $m.on('click', '.mp-del', function () {
            const num = parseInt($(this).closest('li').data('num'));
            self.items = self.items.filter((x) => parseInt(x.num) !== num);
            self._renderList($m);
        });

        // 결과는 바로 아래 목록에 보이므로 alert 로 끊지 않는다.
        // (이미 다 등록돼 있으면 아무 변화 없이 조용히 끝난다)
        $m.on('click', '.mp-add-admins', function () {
            self.adminMembers.forEach((a) => {
                self._add({ num: a.mb_no, name: a.mem_name || a.manage_name || '', left: false });
            });
            self.items = self._sort(self.items);
            self._renderList($m);
        });

        $m.on('click', '.mp-cancel', () => $j.Ui.JBModal.close(MODAL_ID));

        $m.on('click', '.mp-apply', function () {
            self._commit();
            $j.Ui.JBModal.close(MODAL_ID);
        });
    }

    /**
     * 모달 편집분을 위젯(칩 · hidden · data-items)에 반영 → 자동저장까지.
     * '확인'을 누른 시점이 곧 저장 시점이다 — 예전엔 여기까지가 화면 반영이고
     * 하단 [저장] 을 한 번 더 눌러야 했다.
     */
    _commit() {
        const $p = this.$picker;
        if (!$p) return;

        $p.data('items', this.items);
        $p.find('.mp-chips').html(this._chipsHtml(this.items, $p));

        // hidden 값을 JS 로 바꾸면 change 가 저절로 나지 않는다. 페이지의 자동저장이
        // 이 이벤트를 듣고 있으므로 직접 알린다 — 안 그러면 명단만 저장이 안 된다.
        $p.find('input[type=hidden]').val(this.items.map((x) => x.num).join(',')).trigger('change');
    }

    /* ───────────────────────── 내부 ───────────────────────── */

    _add(m) {
        const num = parseInt(m.num);
        if (!num || this.items.some((x) => parseInt(x.num) === num)) return false;

        const row = { num, name: m.name || '(이름없음)', left: !!m.left };

        // 1명 제한 필드는 추가가 아니라 '교체'다 (앱마켓 심사용 계정 등)
        if (this.max === 1) { this.items = [row]; return true; }

        this.items.push(row);
        this.items = this._sort(this.items);
        return true;
    }

    /** 이름 가나다순 — 한글 정렬은 localeCompare('ko'). 동명이인은 회원번호로 가른다. */
    _sort(items) {
        return items.slice().sort((a, b) => {
            const c = String(a.name || '').localeCompare(String(b.name || ''), 'ko');
            return c !== 0 ? c : (parseInt(a.num) - parseInt(b.num));
        });
    }

    _renderList($m) {
        $m.find('.mp-list').html(this.items.map((x) => {
            // 이번 편집에서 새로 추가된 회원 — 아직 저장 전임을 바탕색으로 구분한다
            const isNew = !this.original.has(parseInt(x.num));
            return `
            <li data-num="${x.num}" class="${isNew ? 'is-new' : ''}" title="#${x.num}">
                <span class="mp-name">${this._esc(x.name)}</span>
                ${x.left ? '<span class="mp-left">탈퇴</span>' : ''}
                ${isNew ? '<span class="mp-new">추가됨</span>' : ''}
                <button type="button" class="mp-del" title="삭제">&times;</button>
            </li>`;
        }).join(''));
        $m.find('.mp-empty').text(this.items.length ? '' : '선택된 회원이 없습니다.');
    }

    _search($m, kwd) {
        const self = this;
        $.get(SEARCH_URL, { kwd }, function (rows) {
            const $box = $m.find('.mp-results');
            if (!rows || !rows.length) {
                $box.html('<div class="mp-none">검색 결과가 없습니다.</div>').prop('hidden', false);
                return;
            }
            const has = self.items.map((x) => parseInt(x.num));
            $box.html(rows.map((r) => {
                const dup = has.includes(r.num);
                // 번호 칸은 뺐다 — 동명이인을 가르는 것은 전화번호다(번호는 title 로 남긴다)
                return `<div class="mp-result${dup ? ' is-dup' : ''}" title="#${r.num}"
                             data-num="${r.num}" data-name="${self._esc(r.mem_name)}" data-left="${r.left ? 1 : ''}">
                            <span class="mp-name">${self._esc(r.mem_name)}</span>
                            <span class="mp-phone">${self._esc(r.mem_phone)}</span>
                            ${r.left ? '<span class="mp-left">탈퇴</span>' : ''}
                            ${dup ? '<span class="mp-dup">이미 추가됨</span>' : ''}
                        </div>`;
            }).join('')).prop('hidden', false);
        });
    }

    _hideResults($m) { $m.find('.mp-results').prop('hidden', true).empty(); }

    _esc(s) { return $('<div>').text(s ?? '').html(); }
}
